export enum AccountActionErrors {
  INVALID_EVENT_ID = 'invalid.event.id',
}
